{
  "pages.shell.sidebar": "Page navigation",
  "pages.shell.resize_sidebar": "Adjust navigation width",
  "pages.shell.rename": "Rename",
  "pages.shell.rename_field": "Page name",
  "pages.shell.copy_link": "Copy page link",
  "pages.shell.link_copied": "Page link copied",
  "pages.shell.link_copy_failed": "The link could not be copied.",
  "pages.shell.cycle_blocked": "A page cannot be moved inside one of its own subpages.",
  "pages.shell.move_failed": "The page could not be moved.",
  "pages.shell.start_title": "Where would you like to start?",
  "pages.shell.start_body": "Open a blank page, or begin from a working context. Nothing is created until you apply it.",
  "pages.shell.blank_page": "Blank page",
  "pages.shell.template_blank": "Free-form working page",
  "pages.shell.template_project": "Project and plan working context",
  "pages.shell.template_life": "Life tracking",
  "pages.shell.template_safe": "A preview creates nothing. Records appear only when you apply the template.",
  "pages.shell.full_width": "Full width",
  "pages.shell.narrow_width": "Narrow column",
  "pages.shell.save_status": "Save status",
  "pages.shell.subpages": "Subpages",
  "pages.shell.untitled": "Untitled"
}
